import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AppState {
  state: 'PENDING' | 'WORKING' | 'REJECTED';
  pathname: string;
  hiddenLicenseNotification: boolean;
  activeUserMapper: Record<string, string>;
}

export const initialState: AppState = {
  state: 'PENDING',
  pathname: '',
  hiddenLicenseNotification: false,
  activeUserMapper: {},
};

const app = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAppState: (state, action: PayloadAction<AppState['state']>) => {
      state.state = action.payload;
    },
    setPathname: (state, action: PayloadAction<AppState['pathname']>) => {
      if (state.pathname !== action.payload) {
        state.pathname = action.payload;
      }
    },
    setHiddenLicenseNotification: (state, action: PayloadAction<AppState['hiddenLicenseNotification']>) => {
      state.hiddenLicenseNotification = action.payload || initialState.hiddenLicenseNotification;
    },
    setActiveUserMapper: (state, action: PayloadAction<AppState['activeUserMapper']>) => {
      const { userId, value } = action.payload;
      if (userId && value) {
        state.activeUserMapper[userId] = value;
      }
    },
  },
});

export const { setAppState, setPathname, setHiddenLicenseNotification, setActiveUserMapper } = app.actions;
export default app.reducer;
